export const cardBaseSx = {
  border: '1px solid',
  borderColor: 'ghost.extraLight',
  flex: 1,
} as const;
